import { Button, Tooltip } from '@heroui/react'
import { LinkIcon, ArrowDownTrayIcon } from '@heroicons/react/24/outline'

export interface ActionButtonsProps {
  readonly gifUrl: string
  readonly urlError: boolean
  readonly onCopyUrl: () => void
  readonly gifId: string
  readonly cleanDownloadUrl?: string // Optional clean URL for downloads
}

/**
 * Compact, icon-only Download / Copy-Link actions. Small + light so they can be
 * tucked unobtrusively (e.g. a hover overlay) on a gif tile rather than filling
 * a full footer row.
 */
export const ActionButtons = ({
  gifUrl,
  urlError,
  onCopyUrl,
  cleanDownloadUrl,
}: ActionButtonsProps) => {
  const isDisabled = urlError || !gifUrl
  const downloadUrl = cleanDownloadUrl || gifUrl

  return (
    <div className="flex items-center gap-1">
      <Tooltip content="Download GIF" placement="top">
        <Button
          size="sm"
          variant="light"
          isIconOnly
          as="a"
          href={downloadUrl}
          target="_blank"
          rel="noopener noreferrer"
          isDisabled={isDisabled}
          aria-label="Download GIF"
          className="glass-card-flat text-default-500 hover:text-default-700"
        >
          <ArrowDownTrayIcon className="w-4 h-4" />
        </Button>
      </Tooltip>

      <Tooltip content="Copy Link" placement="top">
        <Button
          size="sm"
          variant="light"
          isIconOnly
          onPress={onCopyUrl}
          isDisabled={isDisabled}
          aria-label="Copy Link"
          className="glass-card-flat text-primary hover:text-primary-600"
        >
          <LinkIcon className="w-4 h-4" />
        </Button>
      </Tooltip>
    </div>
  )
}
